import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import { useMutation } from 'react-query'

import { PartnerContractSignatory } from '../../interfaces/Partners/PartnerContractSignatory'
import { generateContractDiscontinue } from '../../../api/API'
import { useSnackBar } from '../../providers/SnackBarProvider'
import { handleErrorMessages } from '../../utils/handleErrorMessages'
import ContractDiscontinueModal from './ContractDiscontinueModal'

interface Props {
  partnerId: number
}

export const PartnerGenerateContractDiscontinueAgreement = ({ partnerId }: Props) => {
  const { showSnackBar } = useSnackBar()

  const [openGenerateModal, setOpenGenerateModal] = useState(false)

  const onOpenGenerateModal = () => {
    setOpenGenerateModal(true)
  }

  const onCloseGenerateModal = () => {
    setOpenGenerateModal(false)
  }

  const [generateContractMutation, { isLoading }] = useMutation(
    (signatory: PartnerContractSignatory) =>
      generateContractDiscontinue(signatory, partnerId as number),
    {
      onSuccess: (data) => {
        displayPdf(data)
        onCloseGenerateModal()
      },
      onError: (error: any) => {
        showSnackBar({
          severity: 'error',
          text: handleErrorMessages(error),
        })
      },
    }
  )

  const displayPdf = (blob: Blob) => {
    const url = window.URL.createObjectURL(blob)
    window.open(url)
  }

  const onGenerate = (signatory: PartnerContractSignatory) => {
    generateContractMutation(signatory)
  }

  return (
    <Box>
      {openGenerateModal && (
        <ContractDiscontinueModal
          isLoading={isLoading}
          onGenerate={onGenerate}
          onClose={onCloseGenerateModal}
        />
      )}
      <Button variant="outlined" onClick={onOpenGenerateModal}>
        Ģenerēt vienošanos par pārtraukšanu
      </Button>
    </Box>
  )
}
